// integrated-teams/{your-team}/message-templates/{message-template}/src/placements/in-app-v2/{placement-id}/index.tsx

import { noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';
import {
	AnyEdition,
	MauGoal,
	RovoCcpId,
} from '@post-office/shared-contracts/message-template-metadata';

// assertMessageTemplateContext is a validation file created by Post Office's validation library Vindicated. It will be included when you create your message template. You can find out more about vindicated here: https://developer.atlassian.com/platform/post-office/working-with-post-office/technical-deep-dives/vindicated-validation-library/#vindicated:-post-office's-runtime-type-validation-library

import { type MessageTemplateContext } from '../../..';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';
import { LeftNavCtaMessage } from '../../../common/components/LeftNavCtaMessage';
import { type Source } from '../../../common/types';

// Currently we won't look into the message backend, but this is where you can add stages which
// change your message before it gets sent to the frontend.
export const MessageBackend = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: assertMessageTemplateContext,
		stage: () => ({
			goalMetadata: {
				primaryGoal: {
					goalId: MauGoal,
					targetProduct: [RovoCcpId],
					edition: [AnyEdition],
				},
			},
		}),
	},
}));

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	context: {
		experimentCohort: string;
		source: Source;
	};
};

// This is the Message Frontend. In this Placement we have render.Component which takes a React Component which will render your message in the Placement.
export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: noValidation<MessageTemplateContext>(),
		Component: (props: MessageFrontendProps) => (
			<LeftNavCtaMessage {...props} context={{ ...props.context, source: 'confluence-side-nav' }} />
		),
	},
});
